import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/pieces')({
  beforeLoad: () => {
    throw redirect({ to: '/library' });
  },
});
